
// eqn.current.mathField.__controller.blurred=true
import shortid from "shortid";
import React, { useState, useRef, useEffect } from "react";
import { addStyles, StaticMathField } from 'react-mathquill'
import EquationEditor from "equation-editor-react";
import Generalcalc from '../styles/Generalcalc.module.css'
import Calcnav from './Sectionsnav'
import * as regex from '../System/Validation'
import formatlogequation from "../System/Expressionmodifier";
import { formatlimits, fixformatting } from "../System/Expressionmodifier";
import { inequality, findineq } from "../System/Validation";
import { solveProblem } from "../System/Solver";
const nerdamer = require('nerdamer');
require('nerdamer/Algebra');
require('nerdamer/Calculus');
require('nerdamer/Solve');
require('nerdamer/Extra');

//end of importing 
// nerdamer.setConstant('e','2.718281828459045')
// nerdamer.set('PARSE2NUMBER', true);



const getshortid = () => {

  return shortid.generate()
}

addStyles()
function Generalcalculator(props) {

  const [equation, setEquation] = useState('');
  const [evaluatable, seteval] = useState('');
  const [evaluatable2,seteval2]=useState()
  const [iseval1,setiseval1]=useState(true)
  const eqn = useRef()
  const move = () => {
    eqn.current.mathField.__controller.container.css('width', '100%')

  }
  const fieldnavigation = (type) => {
    switch (type) {
      default:
        return eqn.current.mathField.__controller.backspace()
      case 'backspace':

        return eqn.current.mathField.__controller.backspace()
      case 'left':
        return eqn.current.mathField.__controller.moveLeft()
      case 'right':
        return eqn.current.mathField.__controller.moveRight()
      case 'clearall':
        try {
          eqn.current.mathField.__controller.keystroke('Ctrl-A','Keypress')
        } catch (error) {

        }
        
        eqn.current.mathField.__controller.backspace()
        break
    }

  }
  const typetext = (text, shift = null) => {
    eqn.current.mathField.__controller.paste(text)
    if (shift) {
      for (let i = 0; i < shift; i++) {
        eqn.current.mathField.__controller.moveLeft()
      }
    }
  }
  useEffect(() => {
    eqn.current.mathField.__controller.options.substituteTextarea()
    move()
  }, [])
  const calculate = () => {


    let generalsolution = equation
    generalsolution = fixformatting(generalsolution)
    if (regex.fieldchecker(equation) && equation.includes('=') === false) {
      // ..........differentials and space check................
      regex.int_regex.lastIndex = 0
      regex.limit_regex.lastIndex = 0

      //.................integral check......................

      let integral_groups = regex.int_regex.exec(generalsolution)
      while (integral_groups != null) {
        if (!integral_groups[1] && !integral_groups[2] && !integral_groups[5] && !integral_groups[6]) {
          generalsolution = generalsolution.replace(integral_groups[0], `integrate(${integral_groups[3]},${integral_groups[4]})`)
        } else {
          generalsolution = generalsolution.replace(integral_groups[0], `defint(${integral_groups[3] ? integral_groups[3] : integral_groups[7]},${integral_groups[1] ? integral_groups[1] : integral_groups[5]}, ${integral_groups[2] ? integral_groups[2] : integral_groups[6]},${integral_groups[4] ? integral_groups[4] : integral_groups[8]})`)
        }
        integral_groups = regex.int_regex.exec(equation)
      }
      //.............limits check.................
      generalsolution = formatlimits(generalsolution)

      let realsol = solveProblem(generalsolution, false)
      return seteval(realsol)

    } else if (!regex.fieldchecker(equation) && equation.includes('=') && !equation.includes('sum') && !equation.includes('prod')) {

      let realsol = solveProblem(generalsolution, true)
      return seteval(realsol)
    } else if (!regex.fieldchecker(equation) && equation.includes('=') === false && inequality(equation)) {//solve inequality
      let newsol = equation
      newsol = formatlogequation(newsol)
      if (newsol.includes('>')) {
        let match = findineq(newsol)

        let sol = nerdamer(match[1]).gt(match[2])

        return seteval(sol.toString())


      } else if (newsol.includes('<')) {
        let match = findineq(newsol)
        let sol = nerdamer(match[1]).lt(match[2])

        return seteval(sol.toString())

      } else if (newsol.includes('\\le')) {
        let match = findineq(newsol)
        let sol = nerdamer(match[1]).lte(match[2])
        return seteval(sol.toString())
      } else if (newsol.includes('\\ge')) {
        let match = findineq(newsol)

        let sol = nerdamer(match[1]).gte(match[2])
        return seteval(sol.toString())
      }
    }


    else {
      let realsol = solveProblem(generalsolution, false)
      return seteval(realsol)

    }


  }

 function getaltsol(){
  if(!iseval1){
    return setiseval1(true)
  }
  if(!evaluatable.includes(',')){
    let unlex=nerdamer.convertFromLaTeX(evaluatable).toString()
    let newsol=nerdamer(unlex).expand().toString()
    let latex=nerdamer.convertToLaTeX(newsol).toString()
    seteval2(latex)
    if(iseval1){
      return setiseval1(false)
    }

  }else{
    let sollst=evaluatable.split(',')
    let newlist=sollst.map(sol=>{
      let unlex=nerdamer.convertFromLaTeX(sol).toString()
      let newsol=nerdamer(unlex).expand().toString()
      let latex=nerdamer.convertToLaTeX(newsol).toString()
      return latex
    })
    seteval2(String(newlist))
    if(iseval1){
      return setiseval1(false)
    }
  }
 }
  //rendering

  return (
    <div className={Generalcalc.uigrid} style={{height:'100vh'}}>
      
      <div className={`${Generalcalc.editorarea}`}>
        <div className={`${Generalcalc.editor}`}>
          <EquationEditor

            value={equation}
            ref={eqn}
            onChange={(e) => { setEquation(e); seteval('');setiseval1(true) }}
            autoCommands="pi theta sqrt sum prod alpha beta gamma rho"
            autoOperatorNames="sin cos tan sinh cosh tanh" />

        </div>
      </div>


      <div onClick={props.closenav} className={`${Generalcalc.solutionspace}`}>
          {evaluatable ? (<><div className={`${Generalcalc.solution}`}>Solution: </div>
            <div key={getshortid()} onClick={getaltsol} className={Generalcalc.mathsolution}><StaticMathField>{iseval1? evaluatable:evaluatable2}
            </StaticMathField><div className={`${Generalcalc.altsolinfo}`}>Click/Tap for an alternate solution (if possible)</div></div></>) : ''}
      </div>


      <div className={Generalcalc.inputsection} >
        <div onClick={calculate} className={Generalcalc.solvebtn}><span>Solve</span></div>
        <Calcnav input={typetext} navigationbtn={fieldnavigation} />
      </div>

    </div>

  );
}

export default Generalcalculator